export function formattedDriverBespokeFields(bespokeFields = {}) {
	return Object.values(bespokeFields).reduce((arr, item) => {
		for (const key in item) {
			arr.push({ ...item[key], id: key })
		}
		return arr
	}, [])
}
